import { components } from './bundles.schema'

import { Price } from '~/basket/model/common/price.model'

export type BundleMs = components['schemas']['BonusItem']

export interface Bundle extends BundleMs {
  price?: Price[]
}

export enum BundleType {
  PROMOS = 'PROMOS',
  BONUS = 'BONUS',
}

export type GenericError = components['schemas']['GenericError']

interface FormattedBundle extends Bundle {
  durationText: { pretext: string; duration: string; payment: string }[]
}

export interface useBundlesModalReturn {
  isDisabled: boolean
  isOpen: boolean
  setIsOpen: (val: boolean) => void
  tariffName?: string
  formattedTariffPrice: Price[]
  canAddBundle: boolean
  selectedBundles: number[]
  cancelBundlesSet: () => void
  bundlesAndTariffPrice: Price[]
}

export interface useAddBundlesReturn {
  onSelect: (id: number) => void
  availableBundles: FormattedBundle[]
  selected?: number
}

export interface useSelectedBundlesReturn {
  selectedBundles: FormattedBundle[]
  onDeleteBundle: (id: number) => void
}

export interface AddBundleFormProps {
  id: string
  type: BundleType
  preselected?: number
  setAddBundle: (value: boolean) => void
  dataHook: string
}

export interface SelectBundlesSelectors {
  bundlesList: Bundle[]
  selectedBundles: number[]
  selectedTariffId: string | number
  tariffName?: string
  bundlesAndTariffPrice: Price[]
  formattedTariffPrice: Price[]
  bundlesError: boolean
  tariffPrice?: number
}

export interface SelectedBundlesProps {
  id: string
  dataHook: string
  type: BundleType
}
